module.exports = __webpack_public_path__ + "static/media/chevron-left.ef962a7e.svg";